"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var root_category_summary_page_config_service_1 = require("../../../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var root_entity_config_custom_filtering_service_1 = require("../../../../../../shared/services/api/summary-pages/root-entity-config-custom-filtering.service");
var dynamic_navigation_helper_1 = require("../../../../common/utils/dynamic-navigation-helper");
var root_category_provider_service_1 = require("../../../../../../shared/services/api/root-category-provider.service");
var overview_card_type_1 = require("../../../../common/model/overview-card-type");
var overview_config_item_model_1 = require("../../../../common/model/overview-config-item.model");
var summary_pages_navigation_prefix_1 = require("../../../summary-pages-navigation-prefix");
var HeaderNavigationComponent = /** @class */ (function () {
    function HeaderNavigationComponent(rootCategorySummaryPageConfigService, rootEntityConfigCustomFilteringService, formManagementService, rootCategoryProviderService, router, route, navigationPrefix) {
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.rootEntityConfigCustomFilteringService = rootEntityConfigCustomFilteringService;
        this.formManagementService = formManagementService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.router = router;
        this.route = route;
        this.navigationPrefix = navigationPrefix;
        this.overviewCardConfig = new overview_config_item_model_1.OverviewConfigItemModel();
        this.overviewCardConfig.title = 'Overview';
        this.overviewCardConfig.cardType = { id: -1 };
        this.overviewCardConfig.icon = 'icons/ejustice.svg#overview';
    }
    HeaderNavigationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentCardConfig$ = !!this.rootCategoryId
            ? this.rootCategorySummaryPageConfigService.getCardConfigByCategory(this.categoryId, this.rootCategoryId)
                .pipe(operators_1.shareReplay(1))
            : Observable_1.Observable.of(null);
        this.config$ = !!this.rootCategoryId ?
            this.rootCategorySummaryPageConfigService.getConfigByRootCategory(this.rootCategoryId, this.rootEntityId)
                .pipe(operators_1.switchMap(function (config) {
                return _this.rootEntityConfigCustomFilteringService ?
                    _this.rootEntityConfigCustomFilteringService.filter(_this.rootCategoryId, _this.rootEntityId, config.clone())
                    : Observable_1.Observable.of(config);
            }), operators_1.shareReplay(1))
            : Observable_1.Observable.of(null);
        var inDrawer = this.form ? this.form.inDrawer : false;
        this.isAllowNavigation = !!(!inDrawer && this.rootEntityId);
    };
    HeaderNavigationComponent.prototype.ngOnDestroy = function () {
    };
    HeaderNavigationComponent.prototype.onNavigate = function (config, itemConfig) {
        var _this = this;
        if (itemConfig.cardType.id === overview_card_type_1.OverviewCardType.GROUP_CARD) {
            dynamic_navigation_helper_1.navigateToPortfolio(this.navigationPrefix, this.rootCategoryId, this.rootEntityId, itemConfig.itemCategoryName, this.route, this.router)
                .pipe(operators_1.take(1)).subscribe();
        }
        else if (itemConfig.cardType.id === overview_card_type_1.OverviewCardType.MAIN_CARD) {
            dynamic_navigation_helper_1.navigateToForm(this.navigationPrefix, this.rootCategoryId, this.rootEntityId, this.rootCategoryId, this.rootEntityId, itemConfig.form.name, itemConfig.form.id, this.route, this.router)
                .pipe(operators_1.take(1)).subscribe();
        }
        else if (itemConfig.cardType.id === overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD) {
            this.rootCategoryProviderService.getSingleChildEntityId(this.rootCategoryId, this.rootEntityId, itemConfig.itemCategoryName).pipe(operators_1.switchMap(function (entityId) {
                if (entityId) {
                    return dynamic_navigation_helper_1.navigateToForm(_this.navigationPrefix, _this.rootCategoryId, _this.rootEntityId, itemConfig.itemCategoryName, entityId, itemConfig.form.name, itemConfig.form.id, _this.route, _this.router);
                }
                else {
                    if (itemConfig.editForm && itemConfig.editForm.id) {
                        return dynamic_navigation_helper_1.navigateToCreateForm(_this.navigationPrefix, _this.rootCategoryId, _this.rootEntityId, itemConfig.itemCategoryName, itemConfig.editForm.name, itemConfig.editForm.id, _this.route, _this.router);
                    }
                    else {
                        // when no edit form configured, then navigate to first appears edit form
                        return _this.formManagementService.loadFormsByCategoryAndType(itemConfig.itemCategoryName, idm_dynamic_layout_interpreter_1.FormType.EDIT).pipe(operators_1.switchMap(function (forms) {
                            if (forms.length) {
                                return dynamic_navigation_helper_1.navigateToCreateForm(_this.navigationPrefix, _this.rootCategoryId, _this.rootEntityId, itemConfig.itemCategoryName, forms[0].systemName, forms[0].id, _this.route, _this.router);
                            }
                            throw new Error('Form does not exist');
                        }));
                    }
                }
            }), operators_1.take(1)).subscribe();
        }
        else if (itemConfig.cardType.id === overview_card_type_1.OverviewCardType.CUSTOM_CARD) {
            dynamic_navigation_helper_1.navigateToCustomLocation(this.navigationPrefix, itemConfig.customUrl, this.rootCategoryId, this.rootEntityId, this.route, this.router)
                .pipe(operators_1.take(1)).subscribe();
        }
        else if (itemConfig.cardType.id === -1) {
            dynamic_navigation_helper_1.navigateToOverviewForm(this.navigationPrefix, this.rootCategoryId, this.rootEntityId, +config.formId, this.route, this.router)
                .pipe(operators_1.take(1)).subscribe();
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderNavigationComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderNavigationComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderNavigationComponent.prototype, "isView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderNavigationComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderNavigationComponent.prototype, "rootCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderNavigationComponent.prototype, "rootEntityId", void 0);
    HeaderNavigationComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-header-navigation',
            template: require('./header-navigation.component.html'),
            styles: [require('./header-navigation.component.css')]
        }),
        __param(1, core_1.Optional()),
        __param(6, core_1.Optional()), __param(6, core_1.Inject(summary_pages_navigation_prefix_1.SUMMARY_PAGES_NAVIGATION_PREFIX)),
        __metadata("design:paramtypes", [root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            root_entity_config_custom_filtering_service_1.RootEntityConfigCustomFilteringService,
            idm_form_management_ui_1.FormManagementService,
            root_category_provider_service_1.RootCategoryProviderService,
            router_1.Router,
            router_1.ActivatedRoute, String])
    ], HeaderNavigationComponent);
    return HeaderNavigationComponent;
}());
exports.HeaderNavigationComponent = HeaderNavigationComponent;
//# sourceMappingURL=header-navigation.component.js.map